import { AttributeDefinition } from '../attributes/attributeDefinition';
import { AttributeDefinitionCondition } from '../attributes/attributeDefinitionCondition';

export class QuestionDefinitionModel {
  public attributeDefinition: AttributeDefinition;
  public isRequired: boolean;
  public showCurrentValue: boolean;
  public isReadOnly: boolean;
  public isHidden: boolean;
  public descriptionOverride: string;
  public formPageId: string;
  public conditions: AttributeDefinitionCondition[];

  get hasCondition() {
    return this.conditions && this.conditions.length > 0 && this.hasAnyConditionValue;
  }

  get firstCondition() {
    return this.hasCondition ? this.conditions[0] : null;
  }

  private get hasAnyConditionValue(): boolean {
    let result = this.conditions.findIndex((x) => x.conditionValues.length > 0) != -1;
    return result;
  }

  public static convertFromAttributeDefinition(data: AttributeDefinition): QuestionDefinitionModel {
    if (!data) return null;
    let question = new QuestionDefinitionModel();
    question.attributeDefinition = AttributeDefinition.parse(data);
    question.descriptionOverride = data.description ? data.description : data.name;
    question.isRequired = false;
    question.isReadOnly = false;
    question.isHidden = false;
    question.conditions = [];
    return question;
  }
  public static parse(data: any): QuestionDefinitionModel {
    if (!data) return null;

    let question = new QuestionDefinitionModel();
    Object.assign(question, data);

    question.attributeDefinition = AttributeDefinition.parse(question.attributeDefinition);

    return question;
  }
}
